import { apiRaw } from './api';
import { hasConsent } from './cookie-consent';

/**
 * Browser-emittable funnel events (mirrors the server CLIENT_EVENTS allowlist).
 *
 * `alert_opened` deliberately is NOT here. It goes through the PUBLIC beacon
 * (`track` in ./funnel), because alert links open in the Telegram in-app
 * browser without a session and this endpoint would 401 them away — see
 * tender-detail.tsx.
 */
export type ClientEvent = 'tender_opened_on_site';

/**
 * Record a funnel event (TND-8). Fire-and-forget — analytics must never break or
 * block the page, and the endpoint is cookie-authed, so this is only meaningful
 * for signed-in users (callers guard on auth). Failures are swallowed.
 */
export function trackEvent(event: ClientEvent, meta?: Record<string, unknown>): void {
  // Analytics: only under an «analíticas» grant where cookie consent applies (see funnel.ts).
  if (!hasConsent('analytics')) return;
  void apiRaw('/events/track', {
    method: 'POST',
    body: JSON.stringify({ event, meta }),
  }).catch(() => undefined);
}
